import Vue from 'vue'
import axios from 'axios'
import VueCookie from 'vue-cookie'
import { initSlicerJwtToken, initSlicerUser } from '../plugins/localStorage'
import config from '@/helpers/config'

Vue.use(VueCookie)

const state = {
  token: initSlicerJwtToken,
  user: initSlicerUser
}

const mutations = {
  setToken (state, token) {
    state.token = token
  },
  resetToken (state) {
    state.token = ''
  },
  setUser (state, user) {
    state.user = user
  },
  resetUser (state) {
    state.user = {}
  }
}

const actions = {
  async login ({ commit }, user) {
    const endpoint = config.apiUrl + '/admin/users/login/slicer'
    const { data } = await axios.post(endpoint, user)
    if (data.payload.user && data.payload.user.projects && data.payload.user.projects.length > 0) {
      var userProjects = data.payload.user.projects.slice()
      userProjects.sort(function (a, b) {
        var textA = a.name.toUpperCase()
        var textB = b.name.toUpperCase()
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
      })
      data.payload.user.projects = userProjects
    }
    commit('setUser', data.payload.user)
    commit('setToken', data.payload.token)
  },
  logout ({ commit }) {
    commit('resetToken')
    commit('resetUser')
    Vue.cookie.delete('ykx-v2-cookie-jwt-token', {domain: (process.env.NODE_ENV === 'production' ? '.dataslicer.io' : 'localhost')})
    Vue.cookie.delete('ykx-v2-cookie-jwt-user', {domain: (process.env.NODE_ENV === 'production' ? '.dataslicer.io' : 'localhost')})
  }
}

const getters = {
  isLoggedIn (state) {
    if (!state.token) {
      return false
    } else {
      return true
    }
  },
  currentUser (state) {
    if (!state.token) {
      return null
    } else {
      return state.user
    }
  },
  currentToken (state) {
    if (!state.token) {
      return null
    } else {
      return state.token
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js